import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { PageGuideService } from '../../../../page-guide/page-guide.service';
import { Menu } from '../../../menu/menu.model';
import { MenuCategory } from '../menu-category.model';
import { MenuHoverEvent } from '../menu-hover-event.model';
import { MenuService } from '../menu.service';
import { FullMenuService } from '@app/full-menu/full-menu.service';

@Component({
  selector: 'app-menu-category',
  templateUrl: './menu-category.component.html',
  styleUrls: ['./menu-category.component.css']
})
export class MenuCategoryComponent implements OnInit, OnChanges {

  isHovered: boolean;
  availableCategories: Array<MenuCategory>;
  @Input() show: MenuHoverEvent;
  @Input() menuIndex: number;
  @Input() category: Menu;
  @Input() isFullMenuGuied: boolean;
  @Output() showAllOptions: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() clickHideMenu: EventEmitter<string> = new EventEmitter<string>();

  @Input() initialIndex: number;

  @Input() lastMenu:boolean;

  constructor(public translate: TranslateService = null, private menuService: MenuService, private pageGuideService: PageGuideService, private fullMenuService: FullMenuService ) { }

  ngOnInit() {

    this.availableCategories = [];
  }

  ngOnChanges() {

    if (this.category)
      this.availableCategories = this.prepareAvailableCategories();
  }

  openFullMenu() {
    this.onShowAllOptions(true);
    this.menuService.fullMenu(this.translate.currentLang, this.category.name.toLowerCase());
    this.fullMenuService.setMenuTabindex(this.initialIndex);
  }

  onShowAllOptions(event:boolean){
      this.fullMenuService.setMenuTabindex(this.initialIndex);
      this.showAllOptions.emit(event);
  }

  prepareAvailableCategories() {

    let filledMenuOptions = [];

    if (this.category.categories) {
      this.category.categories.forEach(option => {
        if (option.subMenus !== null)
          filledMenuOptions.push(option);
      });
    }
    return filledMenuOptions;
  }

  get menuCategoryId() {

    return this.category.name.toLowerCase() + 'MenuCategory';
  }

  get menuCategoryFullMenuId() {

    return this.category.name.toLowerCase() + 'MenuCategoryFullMenu';
  }

  get showMenuOptions() {

    if (!this.menuIndex)
      return false;
    if (!this.show)
      return false;
    if (this.pageGuideService.isPageGuideActive && !this.isFullMenuGuied)
      return false;

    return this.menuIndex === this.show.index && this.show.buttonIsHovered && !this.show.searchBarIsFocused;
  }

  get categoryHasOptions() {

    if (!this.category)
      return false;

    if (!this.category.categories)
      return false;

    return true;
  }

  get isMenuBlocked(): boolean {

    return this.pageGuideService.isPageGuideActive && this.isFullMenuGuied;
  }

  focusOut(){
    if(this.lastMenu){
      this.clickHideMenu.emit("");
    }
  }

  focus(){
    console.log("recebeu o foco");
  }


  onOpenMenu(url: string) {
    this.clickHideMenu.emit(url);
  }
}
